import * as React from "react";

import S from "./Footer.styled";
import useFooterData from "./useFooterData";

import { useEffect, useState } from "react";
import { Link } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { useLocalization } from "../../../contexts/Localization";
import { IWPImage, IWPLink } from "@/src/types";

type Columns = {
  title: string;
  links: {
    link: IWPLink;
    boxicon?: string;
  }[];
};

type Certificates = {
  title: string;
  image: IWPImage;
  link: IWPLink;
  text: string;
};

const Footer: React.FC = () => {
  const { language } = useLocalization();
  const settingsData = useFooterData(language);
  const data = settingsData?.footer;


  return (
    <S.Footer className="bg-mGray-700 text-white px-9">
      <div className="md:mx-auto md:max-w-7xl relative flex flex-wrap justify-center align-center justify-between block md:grid md:grid-cols-6 py-10 pb-5">
        {data.columns.map((column: Columns, index: number) => (
          <div
            className="flex flex-col md:mb-0 mb-4 md:w-auto w-1/2"
            key={index}
          >
            <h3 className="text-base mt-0">{column.title}</h3>
            {column.links.map((link, index) => (
              <div
                key={index}
                className="text-base block py-1 text-mGray-500 transition duration-400 ease-in-out  hover:text-mGray-200"
              >
                {link?.link &&
                <Link to={link.link.url}>
                  {link?.boxicon && (
                    <i
                      className={link.boxicon + " text-metlab-500 text-3xl"}
                    ></i>
                  )}
                  {link?.link && link.link.title}
                </Link>
                }
              </div>
            ))}
          </div>
        ))}

        {data.certificates.map((certificate: Certificates, index: number) => {
          const certImageData = certificate.image?.localFile?.childImageSharp
            ?.gatsbyImageData
            ? getImage(
                certificate.image.localFile.childImageSharp.gatsbyImageData
              )
            : null;

          return (
            <div
              key={index}
              className="flex flex-grow lg:w-auto w-full items-baseline md:mb-0 mb-4"
            >
              <a href={certificate.link.url} target="_blank">
                <S.FooterCertContainer
                  className={"flex items-center p-2 text-sm"}
                >
                  {certImageData && (
                    <S.FooterCertImage
                      image={certImageData}
                      alt={"Metlab certifikat"}
                      objectFit={"contain"}
                      className={"select-none"}
                    />
                  )}
                  <div className="flex flex-col ml-2">
                    {certificate.text}
                    <br></br>
                    <b>{certificate.link.title}</b>
                  </div>
                </S.FooterCertContainer>
              </a>
            </div>
          );
        })}
      </div>
    </S.Footer>
  );
};

export default Footer;
